(() => {
	let lineup = document.querySelector('.program__lineup');
	if (lineup) {
		const toggleSelectorGrid = '.program__action--grid';
		const toggleSelectorList = '.program__action--list';
		let gridToggle           = document.querySelector(toggleSelectorGrid);
		let listToggle           = document.querySelector(toggleSelectorList);
		if (gridToggle && listToggle) {
			const lineupClassGrid   = 'program__lineup--grid';
			const lineupClassList   = 'program__lineup--list';
			const toggleClassActive = 'program__action--active';
			let statePopped         = false;
			let toggleList          = () => {
				lineup.classList.remove(lineupClassGrid);
				lineup.classList.add(lineupClassList);
				listToggle.classList.add(toggleClassActive);
				gridToggle.classList.remove(toggleClassActive);
			};
			let toggleGrid          = () => {
				lineup.classList.remove(lineupClassList);
				lineup.classList.add(lineupClassGrid);
				gridToggle.classList.add(toggleClassActive);
				listToggle.classList.remove(toggleClassActive);
			};
			let detectState         = () => {
				switch (window.location.hash) {
					case '#list':
						toggleList();
						break;
					case '#grid':
						toggleGrid();
						break;
				}
			};
			window.addEventListener('popstate', () => {
				statePopped = true;
				detectState();
			});
			if (!statePopped) {
				detectState();
			}
		}
	}
})();